import { bindRangeFill } from './utils.js';

/**
 * @template {HTMLElement} T
 * @param {string} id
 * @param {{ new(...args: any[]): T }} ctor
 * @returns {T}
 */
function req(id, ctor) {
    const node = document.getElementById(id);
    if (!node) throw new Error(`Missing required element: #${id}`);
    if (!(node instanceof ctor)) throw new Error(`Element #${id} is not a ${ctor.name}`);
    return node;
}

/**
 * @template {HTMLElement} T
 * @param {string} id
 * @param {{ new(...args: any[]): T }} ctor
 * @returns {T | null}
 */
function opt(id, ctor) {
    const node = document.getElementById(id);
    if (!node) return null;
    if (!(node instanceof ctor)) throw new Error(`Element #${id} is not a ${ctor.name}`);
    return node;
}

export const el = {
    bpmNumber: req('bpmNumber', HTMLInputElement),
    bpmDown: req('bpmDown', HTMLButtonElement),
    bpmUp: req('bpmUp', HTMLButtonElement),
    beatsPerBar: req('beatsPerBar', HTMLSelectElement),
    subdivision: req('subdivision', HTMLSelectElement),
    presetSelect: opt('presetSelect', HTMLSelectElement),
    swingLabel: req('swingLabel', HTMLElement),
    swingPill: opt('swingPill', HTMLElement),
    // Downbeat controls
    downbeatBtn: req('downbeatBtn', HTMLButtonElement),
    volLabel: req('volLabel', HTMLElement),
    volPill: opt('volPill', HTMLElement),
    startStopBtn: req('startStopBtn', HTMLButtonElement),
    resetBtn: req('resetBtn', HTMLButtonElement),
    tapBtn: req('tapBtn', HTMLButtonElement),
    audioEnableBtn: opt('audioEnableBtn', HTMLButtonElement),
    lights: req('lights', HTMLElement),
    log: req('log', HTMLElement),
    aheadLabel: req('aheadLabel', HTMLElement),
    secondaryPulsesNumber: req('secondaryPulsesNumber', HTMLInputElement),
    secondaryRoundsNumber: req('secondaryRoundsNumber', HTMLInputElement),
    secondaryModeNumber: req('secondaryModeNumber', HTMLInputElement),
    unstressedVolRange: req('unstressedVolRange', HTMLInputElement),
    unstressedVolLabel: req('unstressedVolLabel', HTMLElement),
    rhythmStringDisplay: req('rhythmStringDisplay', HTMLElement),
    toggleLogBtn: req('toggleLogBtn', HTMLButtonElement),
    logWrap: req('logWrap', HTMLElement),
    copyPatternBtn: req('copyPatternBtn', HTMLButtonElement),
    exportMidiBtn: req('exportMidiBtn', HTMLButtonElement),
    reverseBtn: opt('reverseBtn', HTMLButtonElement),
    flipBtn: opt('flipBtn', HTMLButtonElement),
    invertBtn: opt('invertBtn', HTMLButtonElement),
    primaryPulsesNumber: req('primaryPulsesNumber', HTMLInputElement),
    primaryRoundsNumber: req('primaryRoundsNumber', HTMLInputElement),
    primaryModeNumber: req('primaryModeNumber', HTMLInputElement),
    primaryStressVolRange: req('primaryStressVolRange', HTMLInputElement),
    primaryStressVolLabel: req('primaryStressVolLabel', HTMLElement),
    secondaryStressVolRange: req('secondaryStressVolRange', HTMLInputElement),
    secondaryStressVolLabel: req('secondaryStressVolLabel', HTMLElement),
    advDetails: opt('advDetails', HTMLDetailsElement),
    primaryPitchRange: req('primaryPitchRange', HTMLInputElement),
    primaryPitchLabel: req('primaryPitchLabel', HTMLElement),
    secondaryPitchRange: req('secondaryPitchRange', HTMLInputElement),
    secondaryPitchLabel: req('secondaryPitchLabel', HTMLElement),
    unstressedPitchRange: req('unstressedPitchRange', HTMLInputElement),
    unstressedPitchLabel: req('unstressedPitchLabel', HTMLElement),
    primaryDecayRange: req('primaryDecayRange', HTMLInputElement),
    primaryDecayLabel: req('primaryDecayLabel', HTMLElement),
    secondaryDecayRange: req('secondaryDecayRange', HTMLInputElement),
    secondaryDecayLabel: req('secondaryDecayLabel', HTMLElement),
    unstressedDecayRange: req('unstressedDecayRange', HTMLInputElement),
    unstressedDecayLabel: req('unstressedDecayLabel', HTMLElement),
};

document.querySelectorAll('input[type="range"]').forEach((node) => {
    bindRangeFill(/** @type {HTMLInputElement} */ (node));
});
